import firebase from "firebase/compat/app";
import config from "./config";

export default firebase.initializeApp(config);
